define('models/filter/index',['require','underscore','models/base/model'],function(require) {
    'use strict';

    var _ = require('underscore');
    var Model = require('models/base/model');

    /*
        schema: [
            {
                name: 'goodsName', // input
                caption: 'Наименование товара', // input
                source: [ // уникальные значения поля // calculated
                    {
                        id: 1,
                        text: 'value1',
                        _disabled: true/false // есть ли эти значения в отфильтрованых
                    },
                    {
                        id: 2,
                        text: 'value2',
                        _disabled: true/false
                    },
                    ...
                ],
                selected: [ // calculated
                    'value1',
                    'value2',
                    ...
                ]
            },
            {
                ....
            }
        ],
        source: [ // input collection
            {
                id: 1,
                goodsName: '...',
                goodsType: '...',
                price: ...
            },
            {
                ...
            }
        ],
        filtered: [ // calculated
            {
                id: 1,
                goodsName: '...',
                goodsType: '...',
                price: ...
            },
            {
                ...
            }
        ]
    */

    function trim(s) {
        return ('' + s).replace(/^\s+|\s+$/gm,'');
    }

    var Filter = Model.extend({
        defaults: {
            visible: false,
            schema: [],
            source: [],
            filtered: []
        },
        constructor: function() {
            Model.apply(this, arguments);
        },
        dispose: function() {
            if (this.disposed) { return; }
            // this.basketCount.dispose();
            Model.prototype.dispose.apply(this, arguments);
        },
        parse: function(data) {
            var source = data.source.slice(0);

            data.source = source;


            function getId(item) {
                return item.id;
            }

            var getNumberId = function (item) {
                return parseInt(item[this.name], 10);
            };

            var getStringId = function (item) {
                return item[this.name];
            };


            var getFieldText = function (item) {
                return trim(''+item[this.name]);
            };

            var initText = function(data) {
                this.source = data.value();
            };

            var initRange = function(data) {
                data = data.pluck('id');

                this.rangeMax = data.max().value() || 0;
                this.rangeMin = data.min().value() || 0;
            };

            var compareRange = function(item) {
                var value;

                if (this.selected.length) {
                    value = parseInt(item[this.name], 10);

                    return (this.selected[0] <= value) && (value <= this.selected[1]);
                }

                return true;
            };

            var compareText = function(item) {
                return this.selected.length ? (_.indexOf(this.selected, trim(item[this.name]))>=0) : true;
            };

            var selectText = function(values) {
                this.selected = values || [];
            };

            var selectRange = function(values) {
                if (values && values.length) {
                    this.selected = [parseInt(values[0], 10), parseInt(values[1], 10)];
                } else {
                    this.selected = [];
                }
            };

            var getBooleanId = function(item){
                return item[this.name];
            };

            var getBooleanText = function(item){
                return item[this.name] + '';
            };

            var compareBoolean = function(item){
                return this.selected.length ? (_.indexOf(this.selected, item[this.name]) >= 0) : true;
            };

            var selectBoolean = function(value) {
                this.selected = [value] || [];
            };

            var initBoolean = function(data){
            };

            // getId - Id элемента фильтрации
            // getText - Название элемента фильтрации
            // init - инициализация поля для элемента фильтрации
            // compare - сравниваем значение (item) с выбранными элементами
            // select - вызывается при выборе 'значения' элемента фильтрации
            var typeHandler = {
                'string': {
                    getId: getStringId,
                    getText: getFieldText,
                    init: initText,
                    compare: compareText,
                    select: selectText
                },
                'number': {
                    getId: getNumberId,
                    getText: getFieldText,
                    init: initText,
                    compare: compareText,
                    select: selectText
                },
                'range': {
                    getId: getNumberId,
                    getText: getFieldText,
                    init: initRange,
                    compare: compareRange,
                    select: selectRange
                },
                'boolean': {
                    getId: getBooleanId,
                    getText: getBooleanText,
                    init: initBoolean,
                    compare: compareBoolean,
                    select: selectBoolean
                }
            };

            data.schema = _.map(data.schema, function(field) {
                field.selected = field.selected || [];

                _.extend(field, typeHandler[field.type || 'string']);

                var data = _(source).map(function(item) {
                        return {
                            id: field.getId(item),
                            text: field.getText(item),
                            _disabled: false
                        };
                    })
                    .filter(function(item) {
                        return item.id !== null;
                    })
                    .sortBy(getId)
                    .uniq(getId, true);

                field.init(data);

                return field;
            });

            data.filtered = this._applyFilter(data.schema, data.source);

            return data;
        },
        setup: function(data) {
            this.set(this.parse(data));
        },
        reset: function(data) {
            var schema = this.get('schema');
            var source = this.get('source');

            _.each(schema, function(item) {
                item.selected = [];
            });

            if (data) {
                _.each(data.schema, function(field) {
                    _.findWhere(schema, { name: field.name }).selected = field.selected;
                });
            }

            var filtered = this._applyFilter(schema, source);

            this.set('filtered', filtered);
        },
        select: function(fieldName, values) {
            var schema = this.get('schema');

            var field = _.findWhere(schema, { name: fieldName });

            field.select(values);

            this.set('filtered', this._applyFilter(schema, this.get('source')));
        },
        getField: function(fieldName) {
            return _.findWhere(this.get('schema'), { name: fieldName });
        },
        getData: function(fieldName) {
            return this.getField(fieldName).source;
        },
        getSelected: function(fieldName) {
            return this.getField(fieldName).selected;
        },
        hasSelection: function() {
            return !!_(this.get('schema')).pluck('selected').flatten().value().length;
        },
        _applyFilter: function(schema, source) {

            var filtered = [], select, i, li, j, lj, item, field;

            source = source || [];

            for (i=0, li=source.length; i<li; i++) {
                select = true;
                item = source[i];
                for (j=0, lj=schema.length; j<lj && select; j++) {
                    select = schema[j].compare(item);
                }
                if (select) {
                    filtered.push(item);
                }
            }

            // var filtered = _.filter(source, function(item) {
            //     var select = true;
            //     for (var i=0, li=schema.length; i<li && select; i++) {
            //         select = schema[i].compare(item);
            //     }
            //     return select;
            // });

            // var text, name, items;
            // for (i=0, li=schema.length; i<li; i++) {
            //     field = schema[i];
            //     name = field.name;
            //     text = '';
            //     for (j=0, lj=filtered.length; j<lj; j++) {
            //         text = text + '/' + filtered[name];
            //     }
            //     text = text || '';
            //     items = field.source || [];
            //     for (j=items.length; j--;) {
            //         item = items[j];
            //         item._disabled = text.indexOf(item.text) === -1;
            //     }
            // }

            // _.each(schema, function(field) {
            //     var flt = _(filtered).map(function(f) { return trim('' + f[field.name]); }).unique().value();
            //     // _.each(field.source, function(s) {
            //     //     s._disabled = _.indexOf(flt, s.text) === -1;
            //     // });
            // });

            return filtered;
        },

        getFilter: function(schema) {
            return _.reduce(schema || this.get('schema'), function(memo, item) {
                memo[item.name] = item.selected;
                return memo;
            }, {});
        },

        setFilter: function(fitler) {
            var schema = this.get('schema');

            _.forEach(fitler, function(value, name) {
                var item = _.findWhere(schema, { name: name });
                if (item) {
                    item.selected = value;
                } else {
                    console.log('Warn field not found', name);
                }
            });

            var hasFilter = this.hasSelection();
            this.set('visible', hasFilter);
            if (hasFilter) {
                this.set('filtered', this._applyFilter(schema, this.get('source')));
            }
            this.trigger('filterChanged');
        }
    });

    return Filter;
});
